<template>
  <div class="main-page">
    <Header></Header>
    <Banner></Banner>
    <div class="m-pc-page page-bottom">
      <List></List>
    </div>
    <div
      v-if="extraItem.extras('copyright.display')"
      class="m-copyright"
      :style="{
        textAlign: extraItem.extras('copyright.position'),
        color: extraItem.extras('copyright.color'),
        fontSize:
          extraItem.extras('copyright.fontSize') === 'big'
            ? '16px'
            : extraItem.extras('copyright.fontSize') === 'small'
            ? '12px'
            : '14px',
        fontWeight:
          extraItem.extras('copyright.bold') === 'bold' ? 'bold' : 'normal',
        fontStyle:
          extraItem.extras('copyright.italic') === 'italic'
            ? 'italic'
            : 'normal',
        whiteSpace: 'pre-line',
        paddingBottom: '30px'
      }"
    >
      {{ extraItem.extras("copyright.model") }}
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../components/Header";
// import Column from "../components/Column.vue";
import Banner from "../components/Banner.vue";
import List from "../components/List.vue";
import { $subscriber } from "fire-wind-water";
// import $ from "jquery";

export default {
  name: "Article",
  data() {
    return {
      extras: {}
    };
  },
  components: {
    Header,
    // Column,
    Banner,
    List
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
  }
};
</script>
